function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/button/upload-file/zodiac-resized",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-File-Icon",
  transform: "translate(0.000000, 0.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "file-icon",
  transform: "translate(5.934783, 0.000000)",
  stroke: "#1B2559"
}, /*#__PURE__*/React.createElement("g", {
  id: "lines",
  transform: "translate(3.130435, 7.826087)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 7.04347826,
  x2: 7.82608696,
  y2: 7.04347826,
  id: "line-3"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 3.91304348,
  x2: 7.82608696,
  y2: 3.91304348,
  id: "line-2"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 0.782608696,
  x2: 5.47826087,
  y2: 0.782608696,
  id: "line-1"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "paper",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "13.5652174 18.6521739 0 18.6521739 -1.18243096e-12 0 8.47826087 2.91569667e-12 13.5652174 5.08695652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "fold",
  strokeLinejoin: "round",
  points: "8.47826087 0 8.47826087 5.08695652 13.5652174 5.08695652"
})), /*#__PURE__*/React.createElement("g", {
  id: "plus-sign",
  transform: "translate(0.000000, 5.934783)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#1B2559",
  fill: "#EBEFFF",
  cx: 6.7826087,
  cy: 6.7826087,
  r: 6.2826087
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#1B2559",
  fillRule: "nonzero",
  points: "7.34782609 6.2173913 10.173913 6.2173913 10.173913 7.34782609 7.34782609 7.34782609 7.34782609 10.173913 6.2173913 10.173913 6.2173913 7.34782609 3.39130435 7.34782609 3.39130435 6.2173913 6.2173913 6.2173913 6.2173913 3.39130435 7.34782609 3.39130435"
}))));

function SvgZodiacResized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZodiacResized);
export default __webpack_public_path__ + "static/media/zodiac-resized.c4907e4b.svg";
export { ForwardRef as ReactComponent };